export enum EnumClaseFactura {
  Normal = 1,
  Anuladora = 2,
  Rectificadora = 3,
  AnuladoraConSustituyente = 4,
  Complementaria = 11,
  Regularizadora = 12,
  Derechos = 13,
  Penalizacion = 14
}
